
export default {
  name: 'CartLineItem',
  props: ['lineItem', 'isLoading'],
  data () {
    return {
      whatsIncludedToggle: false
    }
  },
  computed: {
    country(){
      return this.$store.getters.country
    },
    isIntelligenceAppliances() {
      return this.$config.intelligenceAppliancesEnabled && this.country.code === 'GB'
    },
    isNatedeSmart() {
      return this.lineItem.sku_code === 'NT01AA02'
    },
    product(){
      return this.$store.getters.product(this.lineItem.sku_code)
    },
    localizedName(){
      const locale = this.$i18n.locales.find( l => l.code === this.$i18n.locale)
      return this.product?.metadata?.[`name_${locale.code.toLowerCase()}`] || this.lineItem.name
    },
    lineItemSlug(){
        if (this.lineItem.name.includes('Shelfy')) {
          return '/shelfy'
        } else if (this.lineItem.name.includes('Natede Smart')) {
          return '/natede-smart'
        } else if (this.lineItem.name.includes('Natede Basic')) {
          return '/natede-basic'
        } else if (this.lineItem.name.includes('Eteria')) {
          return '/eteria'
        } else if (this.lineItem.sku_code.includes('RC')) {
          return '/spare-parts'
        } else {
          return '/'
        }
    }
  },
  methods: {
    async updateLineItem(item){
      await this.$store.dispatch('updateLineItem', item)
    },
    async removeLineItem(itemId, item){
      await this.$store.dispatch('removeLineItem', itemId)
      await this.$store.dispatch('getOrder', this.$store.getters.orderId)

      const eventAttributes = {
        "ecommerce": {
          "currency": item.currency_code,
          "order_id": this.$store.getters.orderId,
          "items": [{
            "item_id": item.bundle_code || item.sku_code,
            "item_name": item.name,
            "item_brand": "Vitesy",
            "price": item.unit_amount_float,
            "discount": Math.abs(item.discount_float) / item.quantity,
            "quantity": item.quantity,
            "item_category": item.category
          }]
        }
      }
      this.$gtm.push({ event: 'remove_from_cart', ...eventAttributes })
    }
  }
}
